/**
 * name 热点相关
 * author zhang.yingyu
 * createTime 2019-04-01
 **/
"use strict";
angular.module("hotPointRelateModule",[])
.controller("hotPointRelateCtrl",["$scope","$state","$q","mediaLaboratoryService","trsHttpService","$filter",function($scope,$state,$q,mediaLaboratoryService,trsHttpService,$filter){
     initStatus();
     initData();
    /**
     * [initStatus description]初始化状态
     */
     function  initStatus(){
       $scope.status={
           hotPointPattern:false,
           copyCurrPage:1,
           hotSort:[
               {name:"热度值降序",value:{type:1,order:0}},
               {name:"热度值升序",value:{type:1,order:1}},
               {name:"时间升序",value:{type:2,order:1}},
               {name:"时间降序",value:{type:2,order:0}},
               {name:"分析价值升序",value:{type:3,order:1}},
               {name:"分析价值降序",value:{type:3,order:0}},
           ]
       };
       $scope.data={};
        $scope.page={
            CURRPAGE:1,
            ITEMCOUNT: 0,
            PAGECOUNT: 1,
            PAGESIZE:20,
        };
       $scope.hotRelateParams={
           'modelid':"list",
           'serviceid': 'hotspotAssociation',
           "type":"1",
           "order":"0",
           "page_size": $scope.page.PAGESIZE,
           "page_no":$scope.page.CURRPAGE-1,
           "search_date":""
       };
        $scope.status.hotSortSelected = angular.copy($scope.status.hotSort[0]);
     };
    /**
     * [initData description]初始化数据
     */
     function initData(){
         requestData().then(function(data){
             if(data.PAGEITEMS){
                 getHotDetail(data.PAGEITEMS[0].ID);
             }
         });
     }
     function requestData(){
         var defer=$q.defer();
         $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),$scope.hotRelateParams, "get").then(function(data) {
             $scope.data.hotRelateList = data.PAGEITEMS;
             $scope.page.ITEMCOUNT=data.TOTALITEMCOUNT;
             defer.resolve(data);
         });
         return defer.promise;
     };
    /**
     * [getHotDetail description] 获取热度详情
     */
    function getHotDetail(id){
        var defer=$q.defer();
        var params={
            'modelid':"detail",
            'serviceid': 'hotspotAssociation',
            'id':id,
        };
        $scope.loadingPromise=trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),params,"get").then(function(data){
            $scope.data.detailList=data;
            defer.resolve(data);
        });
        return defer.promise;
    };
    /**
     * [getSplitData description] 将字符串按;分割
     */
    $scope.getSplitData=function(value){
        var arr=[];
        if(!!value){
            arr=value.split(";");
        }
        return arr;
    };
    /**
     * [changeHotPointPattern description]点击切换图表或者列表模式
     */
     $scope.changeHotPointPattern=function(){
         $scope.status.hotPointPattern=!$scope.status.hotPointPattern;
         if($scope.status.hotPointPattern){
             $scope.hotRelateParams.search_date=$filter('date')(new Date(), 'yyyy-MM-dd');
             $scope.hotTimeSelect=$scope.hotRelateParams.search_date;
             requestData();
         }else{
             $scope.hotTimeSelect="";
         }
     };
    /**
     * [getHotPointTime description] 获取热点时间
     */
    $scope.getHotPointTime=function(time){
       if(!!time){
           return $filter('date')(new Date(time), 'MM-dd HH:mm:ss');
       }
    };
    /**
     * [toHotPointDetail description] 热点详情
     */
     $scope.toHotPointDetail=function(data){
         mediaLaboratoryService.checkHotPointDetail(data, function() {
             requestData();
         });
     };
    /**
     * [queryByDropdown description] 下拉选择
     */
     $scope.queryByDropdown=function(type,data){
         $scope.hotRelateParams.type=data.value.type;
         $scope.hotRelateParams.order=data.value.order;
         $scope.page.CURRPAGE = 1;
         $scope.hotRelateParams.page_no=$scope.page.CURRPAGE-1;
         requestData();
     };
    $scope.$watch('hotTimeSelect', function(newval, oldval) {
        $scope.hotRelateParams.search_date = $filter('date')(newval, 'yyyy-MM-dd');
        requestData();
    });
    /**
     * [toHotPointDetail description] 监听点击散点图数据
     */
    $scope.$on("getScatterData",function(event,data){
        $scope.data.detailList=data.tranDatas[2].detail;
    });
    /**
     * [toStartAnalysis description] 开始分析
     */
    $scope.toStartAnalysis=function(){
        $state.go("hotpointatlas");
    };
    /**
     * [pageChanged description:下一页]
     */
    $scope.pageChanged = function() {
        $scope.status.copyCurrPage = $scope.page.CURRPAGE;
        $scope.hotRelateParams.page_no=$scope.page.CURRPAGE-1;
        requestData();
    };
    /**
     * [jumpToPage description:跳转指定页面]
     */
    $scope.jumpToPage = function() {
        if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
            $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
        }
        $scope.page.CURRPAGE = $scope.status.copyCurrPage;
        $scope.hotRelateParams.page_no=$scope.page.CURRPAGE-1;
        requestData();
    };
    /**
     * [selectPageNum description]选择单页显示个数
     * @return {[type]} [description] null
     */
    $scope.selectPageNum = function() {
        $scope.status.copyCurrPage=1;
        $scope.hotRelateParams.page_no=$scope.page.CURRPAGE-1;
        $scope.hotRelateParams.page_size=$scope.page.PAGESIZE;
        requestData();
    };
}]);